import * as types from './mutation-types'

export default {
  [types.SET_ITEM_GATHER] (state, itemState) {
    state.itemGather = itemState
  }
}
